module.exports = __webpack_public_path__ + "static/media/Kelly.f2d9b099.png";